import React, { useRef } from 'react';

import { Submenu, SubmenuItem } from '../../components';
import { documentsService } from '../../service/services/DocumentsService';
import { getDateTimeString, smoothScroll } from '../../utils/functions';
import { Hidden } from '@material-ui/core';

import {
	Container,
	Title,
	BoxContainer,
	Box,
	Content,
	Block,
	Icon,
} from './styles';

const Button = ({ label, onClick }) => (
	<button onClick={onClick}>
		<Icon />
		<span>{label}</span>
	</button>
);

export default () => {
	const regulamentacaoRef = useRef(null);
	const contratoRef = useRef(null);
	const caracteristicaRef = useRef(null);
	const divulgacaoRef = useRef(null);
	const outrosRef = useRef(null);

	const getFile = async path => {
		try {
			const response = await documentsService.downloadDocumento(path);
			const responseData = await response.data;

			const blob = new Blob([responseData], {
				type: 'application/pdf',
			});

			const downloadUrl = window.URL.createObjectURL(blob);

			const link = document.createElement('a');

			link.href = downloadUrl;
			link.download = `${path.replace('/', '')}PDF_${getDateTimeString()}.pdf`;

			document.body.appendChild(link);

			link.click();
			link.remove();
		} catch (err) {
			console.error(
				'Ocorreu um erro ao chamar a API de Download - Erro: ',
				err,
			);
		}
	};

	const handleDownloadAssemble = async ()=> {
		try {
			await getFile("/Divulgacao/Assembleias/AtasAssembleias")
			await getFile("/Divulgacao/Assembleias/CartaConsulta")
			await getFile("/Divulgacao/Assembleias/EditalDaConvocao")
		} catch (err) {
			console.error(
				'Ocorreu um erro ao chamar a API de Download - Erro: ',
				err,
			);
		}
	};

	const handleDownloadClick = path => getFile(path);

	return (
		<Container>
			<Hidden mdUp>
				<Title>Documentos</Title>
			</Hidden>
			<Hidden smDown>
				<Submenu>
					<SubmenuItem
						onClick={() => smoothScroll('#regulamentacao')}
						label="Regulamentação"
					/>
					<SubmenuItem
						onClick={() => smoothScroll('#contrato')}
						label="Contratos"
					/>
					<SubmenuItem
						onClick={() => smoothScroll('#caracteristica')}
						label="Características"
					/>
					<SubmenuItem
						onClick={() => smoothScroll('#divulgacao')}
						label="Divulgação"
					/>
					<SubmenuItem onClick={() => smoothScroll('#outros')} label="Outros" />
				</Submenu>
			</Hidden>

			<BoxContainer>
				<Box>
					<Content ref={regulamentacaoRef}>
						<Block>
							<h2 id="regulamentacao">Regulamentação</h2>
							<Button
								label="Regulamento"
								onClick={() =>
									handleDownloadClick('/Regulamentacao/Regulamento')
								}
							/>
							<Button
								label="ICVM 359"
								onClick={() => handleDownloadClick('/Regulamentacao/ICVM359')}
							/>
							<Button
								label="IN 1585"
								onClick={() => handleDownloadClick('/Regulamentacao/IN1585')}
							/>
						</Block>
					</Content>
				</Box>

				<Box>
					<Content ref={contratoRef} className="align-right">
						<Block className="gray">
							<h2 id="contrato">Contratos</h2>
							<Button
								label="Contrato de Agente autorizado"
								onClick={() =>
									handleDownloadClick('/Contratos/ContratoAgenteAutorizado')
								}
							/>
							<Button
								label="Contrato de licenciamento do índice"
								onClick={() =>
									handleDownloadClick('/Contratos/ContratoLicenciamentoIndice')
								}
							/>
							<Button
								label="Contrato de Formador de mercado"
								onClick={() =>
									handleDownloadClick('/Contratos/ContratoFormadorMercado')
								}
							/>
							<Button
								label="Contrato de distribuição"
								onClick={() =>
									handleDownloadClick('/Contratos/ContratoDistribuicao')
								}
							/>
						</Block>
					</Content>
				</Box>

				<Box>
					<Content ref={caracteristicaRef}>
						<Block>
							<h2 id="caracteristica">Características</h2>
							<Button
								label="Metodologia do Índice"
								onClick={() =>
									handleDownloadClick('/Caracteristicas/MetodologiaIndice')
								}
							/>
							{/* <Button
								label="Metodologia do ETF GENB11"
								onClick={() =>
									handleDownloadClick('/Caracteristicas/MetodologiaETFESGB11')
								}
							/> */}
							<Button
								label="Fatores de risco"
								onClick={() =>
									handleDownloadClick('/Caracteristicas/FatoresRisco')
								}
							/>
							<Button
								label="Política de empréstimo"
								onClick={() =>
									handleDownloadClick('/Caracteristicas/PoliticaEmprestimo')
								}
							/>
						</Block>
					</Content>
				</Box>

				<Box>
					<Content ref={divulgacaoRef} className="align-right">
						<Block className="gray">
							<h2 id="divulgacao">Divulgação</h2>
							<Button
								label="Oferta"
								onClick={() =>
									handleDownloadClick('/Divulgacao/DemonstracoesFinanceiras')
								}
							/>
							<Button
								label="Relatório anual"
								
							/>
							<Button
								label="Fatos relevantes"
								onClick={() =>
									handleDownloadClick('/Divulgacao/FatosRelevantes')
								}
							/>
							<Button
								label="Assembleias"
								onClick={() => handleDownloadAssemble()}
							/>
						</Block>
					</Content>
				</Box>

				<Box>
					<Content ref={outrosRef}>
						<Block>
							<h2 id="outros">Outros</h2>
							<Button
								label="Formulário de solicitação de movimentação"
								onClick={() =>
									handleDownloadClick(
										'/Outros/FormularioSolicitacaoMovimentacao',
									)
								}
							/>
							<Button
								label="Requerimento de empréstimo"
								onClick={() =>
									handleDownloadClick('/Outros/RequerimentoEmprestimo')
								}
							/>
							{/* <Button
								label="Responsabilidades e direitos"
								onClick={() =>
									handleDownloadClick('/Outros/ResponsabilidadesDireitos')
								}
							/> */}
						</Block>
					</Content>
				</Box>
			</BoxContainer>
		</Container>
	);
};
